import React from "react";
import {Language} from "../../util/enum";
import {TemplateContent} from "./templateEditContentList";
import {ReplaceableInfo, replaceWithReplaceableInfo} from "./templateEditor";

interface IProps {
    title?: string,
    data: Array<TemplateContent>,
    replaceableInfo?: ReplaceableInfo,
}

export default function TemplatePreviewContentList(props: IProps) {
    const {title, data, replaceableInfo} = props

    const $actionFooter = (name: string) => {
        return <div className={"flex flex-row items-center justify-center my-2.5"}>
            <p className={"text-sm text-gray-2"}>{name}</p>
        </div>
    }

    const $readOnlyFooter = (language: string) => {
        return <p className={"inline-flex text-sm text-gray-2 my-2.5"}>
            {language}</p>
    }

    const $templateItem = ({compliedMessage, name, language}: TemplateContent, idx: number) => {
        if (!compliedMessage.length) {
            return null
        }

        const descriptionMessage = replaceWithReplaceableInfo(compliedMessage, replaceableInfo)

        return (
            <div key={idx} className={"border-b border-gray-200 mb-2.5"}>
                <p className={"text-base break-words"}>{descriptionMessage}</p>
                <div className={"w-full flex flex-row-reverse"}>
                    {language === Language.english ? $readOnlyFooter(name || language) : $actionFooter(name || language)}
                </div>
            </div>
        )
    }

    const $title = title && title.length ? (<p className={"relative font-semibold text-gray-3 text-sm text-left mb-1"}>{title}</p>) : null
    return (
        <div>
            {$title}
            <div className={"w-full bg-gray-6 p-5 rounded"}>
                {data.map((_item, idx) => {
                    return $templateItem(_item, idx)
                })}
            </div>
        </div>
    )
}
